import { useQuery } from '@tanstack/react-query';
import { offersApi } from '../api/offers.api';
import { useDirection } from '@/contexts/DirectionContext';

interface UseOfferHtmlResult {
  data: string | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
}

/**
 * Fetch lazy al HTML-ului unei oferte (`GET /offers/:id/view`). Disabled
 * până când e furnizat un id valid (modalul deschis pe un card concret).
 *
 * Pipeline-ul backend e: client backend → app principală (offer-internal),
 * cu validare de acces + secret intern.
 */
export function useOfferHtml(id: number | null | undefined): UseOfferHtmlResult {
  const { direction } = useDirection();
  const query = useQuery<string>({
    queryKey: ['offers', 'html', id, direction],
    queryFn: async () => {
      const res = await offersApi.viewOffer(id as number, direction);
      return res.html || '';
    },
    enabled: typeof id === 'number' && id > 0,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
  };
}
